import { TIMER } from "../../Gameplay";
import { RoundManager } from "../../Round/RoundManager";
import { Stadium } from "../../Stadium/Stadium";
import { TargetManager } from "../TargetManager";
import { CornerTarget } from "../Targets/CornerTarget";
import { TargetBase } from "../Targets/Target";
import { TargetSettingsBase } from "../TargetSettings";
import { eTargetType } from "../TargetType";
import { TargetControllerBase } from "./BaseController";


export const enum eCornerTargetPos {
    /**
     * Horni levy roh
     */
    topLeft,
    /**
     * Dolni levy roh
     */
    botLeft,
    /**
     * Horni pravy roh
     */
    topRight,
    /**
     * Dolni pravy roh
     */
    botRight,
    /**
     * Levy horni nebo dolni roh. Vertikalni pozice se urci podle vertikalni pozice hlavniho terce
     */
    left,
    /**
     * Pravy horni nebo dolni roh. Vertikalni pozice se urci podle vertikalni pozice hlavniho terce
     */
    right,
    top,
    bot
}



export class CornerTargetSettings extends TargetSettingsBase {
    get pos(): eCornerTargetPos { return this._pos; }
    private _pos: eCornerTargetPos;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(pos: eCornerTargetPos) {
        super(eTargetType.corner, 1, 0);

        this._pos = pos;
    }
}



export class CornerTargetController extends TargetControllerBase {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(target: TargetBase, settings: CornerTargetSettings): void {
        super.init(target, settings);

        // Pozice
        let pos = settings.pos;

        if (pos >= eCornerTargetPos.left) {
            let mainTarget = TargetManager.instance.mainTarget;
            let mainTargetPos = mainTarget.getPositionInTime(TIMER.time);

            if (pos <= eCornerTargetPos.right) {
                // Urcit zda se rohovy terc ma umistit nahore nebo dole
                if (mainTargetPos.y < Stadium.GOAL_HEIGHT / 2) {
                    // Umistit nahore
                    pos = pos == eCornerTargetPos.left ? eCornerTargetPos.topLeft : eCornerTargetPos.topRight;
                }
                else {
                    // Umistit dole
                    pos = pos == eCornerTargetPos.left ? eCornerTargetPos.botLeft : eCornerTargetPos.botRight;
                }
            }
            else {
                // Urcite zda se rohovy terc ma umistit vlevo nebo v pravu
                if (mainTargetPos.x < Stadium.GOAL_WIDTH / 2) {
                    // Umistit vpravo
                    pos = pos == eCornerTargetPos.top ? eCornerTargetPos.topRight : eCornerTargetPos.botRight;
                }
                else {
                    // Umistit vlevo
                    pos = pos == eCornerTargetPos.top ? eCornerTargetPos.topLeft : eCornerTargetPos.botLeft;
                }
            }
        }

        // Nastavit pozici terce
        this.convertRatioPos2WorldPos((pos & 2) == 0 ? 0 : 1, (pos & 1) == 0 ? 1 : 0);
        this._target.container.setPosition(this._pos.x, this._pos.y, Stadium.END_Z - 0.05);

        // Nastavit rotaci terce
        (this._target as CornerTarget).setOriginPos(pos);
    }
}